'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwDropdownMulti = require('./CwDropdownMulti.scss');

var _CwDropdownMulti2 = _interopRequireDefault(_CwDropdownMulti);

var _CwCheckBox = require('../cwcheckbox/CwCheckBox');

var _CwCheckBox2 = _interopRequireDefault(_CwCheckBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

var CwDropdownMultiItem = function (_React$Component) {
  (0, _inherits3.default)(CwDropdownMultiItem, _React$Component);

  function CwDropdownMultiItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CwDropdownMultiItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CwDropdownMultiItem.__proto__ || (0, _getPrototypeOf2.default)(CwDropdownMultiItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      if (_this.props.onClick) {
        _this.props.onClick(_this.props.item);
      }
    }, _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(_this.props.index, { x: event.clientX, y: event.clientY });
      }
    }, _this.handleMouseDown = function () {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(true);
      }
    }, _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove({ x: event.clientX, y: event.clientY });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CwDropdownMultiItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var itemStyle = void 0;
      if (this.props.isPicker) {
        itemStyle = this.props.isHighlighted ? _CwDropdownMulti2.default.dropDownHighlightedPicker : _CwDropdownMulti2.default.dropDownPicker;
      } else {
        itemStyle = this.props.isHighlighted ? _CwDropdownMulti2.default.dropDownHighlightedItem : _CwDropdownMulti2.default.dropDownItem;
      }
      return _react2.default.createElement(
        'div',
        { className: itemStyle,
          onClick: this.handleClick,
          onMouseEnter: this.handleMouseEnter,
          onMouseDown: this.handleMouseDown,
          onMouseMove: this.handleMouseMove,
          ref: function ref(div) {
            return _this2.div = div;
          } },
        _react2.default.createElement(_CwCheckBox2.default, { text: this.props.item.name, value: this.props.isChecked })
      );
    }
  }]);
  return CwDropdownMultiItem;
}(_react2.default.Component);

CwDropdownMultiItem.propTypes = {
  /**
   * Determines whether the current dropdown item is highlighted
   */
  isHighlighted: _propTypes2.default.bool,
  /**
   * Determines whether the current dropdown item is the picker
   */
  isPicker: _propTypes2.default.bool,
  /**
   * The dropdown item being rendered. Must contain at least "id" and "name" fields.
   */
  item: _propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    name: _propTypes2.default.string
  }),
  /**
   * Callback function that is fired when dropdown item is clicked.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function that is fired when dropdown item is hovered over.
   */
  onMouseEnter: _propTypes2.default.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown item from derezzing before a selection is registered.
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * The index of the dropdown item being rendered.
   */
  index: _propTypes2.default.number,
  isChecked: _propTypes2.default.bool
};

CwDropdownMultiItem.defaultProps = {
  item: { id: null, name: null }
};

exports.default = CwDropdownMultiItem;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdropdown/CwDropdownMultiItem.js
// module id = 835
// module chunks = 10